import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "chat-wrapper pa-2 ma-2 tap-on"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "d-flex flex-column align-self-end pb-2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "grey--text text-caption" }
const _hoisted_11 = {
  key: 1,
  class: "d-flex justify-end align-center reative"
}
const _hoisted_12 = { class: "grey--text text-caption align-self-end pb-2" }
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "align-self-end" }
const _hoisted_16 = {
  key: 0,
  class: "chat-wrapper staff-chat pa-2 ma-2 group-chat no-tap",
  style: {"user-select":"none"}
}
const _hoisted_17 = { style: {"white-space":"pre-line"} }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 1,
  oncontextmenu: "return false;",
  class: "chat-wrapper staff-chat pa-2 ma-2 no-tap",
  style: {"white-space":"pre-line","user-select":"none"}
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 1,
  class: "autolinked",
  style: {"pointer-events":"none"}
}
const _hoisted_22 = { class: "input-wrapper pa-1" }
const _hoisted_23 = {
  key: 0,
  class: "primary--text font-weight-bold"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "d-flex justify-space-around mb-3 mt-3 comment-dialog-quick-row--outlined" }
const _hoisted_26 = { class: "comment-dialog-quick-btn__inner" }
const _hoisted_27 = { class: "comment-dialog-quick-btn__label" }
const _hoisted_28 = { class: "comment-dialog-quick-btn__inner" }
const _hoisted_29 = { class: "comment-dialog-quick-btn__label" }
const _hoisted_30 = { class: "d-flex justify-space-around mb-3 mt-3 comment-dialog-quick-row--flat" }
const _hoisted_31 = { class: "comment-dialog-quick-btn__inner" }
const _hoisted_32 = { class: "comment-dialog-quick-btn__label" }
const _hoisted_33 = { class: "comment-dialog-quick-btn__inner" }
const _hoisted_34 = { class: "comment-dialog-quick-btn__label" }
const _hoisted_35 = { class: "d-flex justify-space-around mb-3 mt-3 comment-dialog-quick-row--flat" }
const _hoisted_36 = { class: "comment-dialog-quick-btn__inner" }
const _hoisted_37 = { class: "comment-dialog-quick-btn__label" }
const _hoisted_38 = { class: "comment-dialog-quick-btn__inner" }
const _hoisted_39 = { class: "comment-dialog-quick-btn__label" }
const _hoisted_40 = { class: "d-flex justify-space-around pt-3 pb-3" }
const _hoisted_41 = {
  key: 0,
  class: "d-flex px-3"
}
const _hoisted_42 = { class: "d-flex justify-space-around pt-3 pb-3" }
const _hoisted_43 = { class: "d-flex flex-column" }
const _hoisted_44 = { class: "pdf_header_wrapper" }
const _hoisted_45 = { class: "pdf" }
const _hoisted_46 = ["data"]
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "pdf-fallback" }
const _hoisted_49 = ["href"]
const _hoisted_50 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_DatePager = _resolveComponent("DatePager")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_MessageHandle = _resolveComponent("MessageHandle")!
  const _component_VueLoading = _resolveComponent("VueLoading")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_TranslationModal = _resolveComponent("TranslationModal")!
  const _component_AbsenceModal = _resolveComponent("AbsenceModal")!
  const _component_AbsenceDeleteModal = _resolveComponent("AbsenceDeleteModal")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_locale_provider = _resolveComponent("v-locale-provider")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[27] || (_cache[27] = () => ((_ctx.deleteArea = ''), (_ctx.actionDialog = false))),
    class: "no-tap"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_app_bar, {
        color: "primary",
        flat: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            style: {"position":"absolute"},
            icon: "mdi-chevron-left",
            to: '/'
          }),
          _createVNode(_component_v_spacer),
          (_ctx.child)
            ? (_openBlock(), _createBlock(_component_v_toolbar_title, {
                key: 0,
                style: {"min-width":"fit-content"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString((_ctx.child.lastName + ' ' + _ctx.child.firstName).length > 11
                ? (_ctx.child.lastName + ' ' + _ctx.child.firstName).slice(0, 11) + '…' 
                : _ctx.child.lastName + ' ' + _ctx.child.firstName), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            color: "primary",
            depressed: "",
            fab: "",
            onClick: _ctx.openSelectChildDialog,
            loading: _ctx.btnLoadingChat,
            height: "40",
            width: "40"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { color: "white" }, {
                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                  _createTextVNode(" mdi-arrow-down-drop-circle-outline ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick", "loading"]),
          (_ctx.chatComment)
            ? (_openBlock(), _createBlock(_component_v_badge, {
                key: 1,
                dot: "",
                color: "#E190CF",
                "offset-x": "8",
                "offset-y": "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_app_bar_nav_icon, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog = true))
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                key: 2,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialog = true))
              }))
        ]),
        _: 1
      }),
      (_ctx.isChatCreateUserMe)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            rounded: "0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openDateDialog && _ctx.openDateDialog(...args)))
              }, [
                _createVNode(_component_DatePager, {
                  date: _ctx.date,
                  onAddDay: _ctx.addDay,
                  onSubtractDay: _ctx.subtractDay,
                  isYear: false,
                  beforeTheDate: _ctx.unReadCount ? _ctx.unReadCount.beforeTheDate : 0,
                  afterTheDate: _ctx.unReadCount ? _ctx.unReadCount.afterTheDate : 0
                }, null, 8, ["date", "onAddDay", "onSubtractDay", "beforeTheDate", "afterTheDate"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_divider)
    ]),
    (!_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "chat-area",
            onScroll: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tap())),
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleLinkClick && _ctx.handleLinkClick(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatPast, (chat, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "d-flex flex-column"
              }, [
                (chat.from)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_3, [
                        (chat.bodyType === 'absence' || chat.bodyType === 'pickup')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "info-wrapper parents-chat pa-2 ma-2",
                              style: {"white-space":"pre-line"},
                              innerHTML: _ctx.escapeAndLinkify(_ctx.translatedChats[chat.chatId] ?? chat.body)
                            }, null, 8, _hoisted_4))
                          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("p", {
                                style: {"white-space":"pre-line","color":"primary"},
                                innerHTML: _ctx.escapeAndLinkify(_ctx.translatedChats[chat.chatId] ?? chat.body)
                              }, null, 8, _hoisted_6)
                            ])),
                        _createElementVNode("div", _hoisted_7, [
                          (!_ctx.translatedChats[chat.chatId] && chat.bodyType === 'message')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_component_v_btn, {
                                  style: {"height":"18px","color":"#000000","border-color":"#000000","border-width":"1px"},
                                  onClick: ($event: any) => (_ctx.openTranslateDialog(chat))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "small" }, {
                                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                        _createTextVNode("mdi-google-translate", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.translatedChats[chat.chatId] && chat.bodyType === 'message')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_component_v_btn, {
                                  style: {"height":"16px","color":"#000000","border-color":"#000000","border-width":"1px"},
                                  onClick: ($event: any) => (_ctx.returnTranslate(chat.chatId))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "small" }, {
                                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                        _createTextVNode("mdi-arrow-u-left-top", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatTime(chat.deliveredAt || chat.createdAt)), 1)
                        ])
                      ]),
                      (!chat.readAt)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            label: "",
                            color: "error",
                            variant: "outlined",
                            class: "pa-3 ml-2 mb-4",
                            style: {"width":"40%","z-index":"0"},
                            disabled: _ctx.btnLoadingChat,
                            onClick: ($event: any) => (_ctx.dblClick(chat))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { left: "" }, {
                                default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                  _createTextVNode("mdi-check", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(_toDisplayString(_ctx.$t('communication.confirm')), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]))
                        : _createCommentVNode("", true),
                      (chat.readAt)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 1,
                            label: "",
                            color: "",
                            variant: "outlined",
                            class: "pa-2 ml-2 mb-4",
                            style: {"width":"40%","z-index":"0"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('communication.confirmed')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (!chat.from)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          (chat.readAt)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('communication.read')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.formatTime(chat.deliveredAt || chat.createdAt)), 1)
                        ])
                      ]),
                      (chat.bodyType === 'groupChat')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", null, [
                              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('communication.contactEmail') + '\n'), 1),
                              _createElementVNode("div", {
                                innerHTML: _ctx.escapeAndLinkify(chat.body)
                              }, null, 8, _hoisted_18)
                            ]),
                            _withDirectives(_createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chat.attachmentUrls, (au, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: au.objectKey
                                }, [
                                  (!_ctx.isPdf(au.objectKey))
                                    ? (_openBlock(), _createBlock(_component_v_card, {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.openChatImg(chat, index)),
                                        class: "pointer mt-1",
                                        style: {"min-width":"64vw"},
                                        elevation: "0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_img, {
                                            src: au.url,
                                            contain: ""
                                          }, null, 8, ["src"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 1,
                                        class: "my-3",
                                        color: "primary",
                                        dark: "",
                                        variant: "text",
                                        size: "small",
                                        onClick: ($event: any) => (_ctx.openChatImg(chat, index)),
                                        loading: _ctx.imgLoading
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('communication.showAttachment')), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["onClick", "loading"]))
                                ]))
                              }), 128))
                            ], 512), [
                              [_vShow, chat.attachmentUrls.length]
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            (_ctx.isLink(chat.body))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  innerHTML: _ctx.escapeAndLinkify(chat.body),
                                  class: "autolinked"
                                }, null, 8, _hoisted_20))
                              : (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(chat.body), 1))
                          ])),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        variant: "plain",
                        onClick: ($event: any) => (_ctx.handleContentClick(chat, $event)),
                        small: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                              _createTextVNode("mdi-dots-vertical-circle-outline", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 32),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_v_divider, { class: "mb-2" }),
            (!_ctx.isChatCreateUserMe)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t('communication.viewOnly')), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_v_textarea, {
              variant: "outlined",
              modelValue: _ctx.inputText,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputText) = $event)),
              "auto-grow": "",
              rows: "1",
              "row-height": "15",
              "hide-details": "",
              density: "compact",
              class: "input-chat-area pa-0",
              color: "primary"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_MessageHandle, {
              onSaveDraft: _ctx.saveDraft,
              onSaveSendReady: _ctx.saveSendReady,
              onSendMessage: _ctx.sendMessage,
              btnSendLoading: _ctx.btnSendLoading,
              btnDraftLoading: _ctx.btnDraftLoading,
              btnReadyLoading: _ctx.btnReadyLoading,
              inputText: _ctx.inputText,
              isChatCreateUserMe: _ctx.isChatCreateUserMe
            }, null, 8, ["onSaveDraft", "onSaveSendReady", "onSendMessage", "btnSendLoading", "btnDraftLoading", "btnReadyLoading", "inputText", "isChatCreateUserMe"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(_component_VueLoading, { height: '50vh' })
        ])),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogSelectChild,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogSelectChild) = $event)),
      width: "280px",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "selectItemList pb-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.selectedClass,
                  "onUpdate:modelValue": [
                    _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedClass) = $event)),
                    _ctx.selectChildItems
                  ],
                  items: _ctx.classList,
                  "item-title": "className",
                  "item-value": "classId",
                  variant: "filled",
                  "hide-details": "",
                  "return-object": "",
                  color: "rgb(105,105,105)"
                }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, {
              style: {"height":"40vh"},
              class: "childList"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childList, (c, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: index,
                        onClick: ($event: any) => (_ctx.toClassChildren(c))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_content, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(c.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialog) = $event)),
      class: "comment-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "headline lighten-2" }),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_v_btn, {
                class: _normalizeClass(["comment-dialog-quick-btn", { 'comment-dialog-quick-btn--ja': _ctx.isJapaneseLocale }]),
                color: "primary",
                variant: "outlined",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onClickAbsencedeleteDialog()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('communication.absenceConfirmDelete')), 1),
                    _createVNode(_component_v_icon, {
                      class: "comment-dialog-quick-btn__chevron",
                      size: "20"
                    }, {
                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_btn, {
                class: _normalizeClass(["comment-dialog-quick-btn", { 'comment-dialog-quick-btn--ja': _ctx.isJapaneseLocale }]),
                color: "primary",
                variant: "outlined",
                onClick: _ctx.openAbsenceRegistDialog
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('absence.title')), 1),
                    _createVNode(_component_v_icon, {
                      class: "comment-dialog-quick-btn__chevron",
                      size: "20"
                    }, {
                      default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["class", "onClick"])
            ]),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_v_btn, {
                class: _normalizeClass(["comment-dialog-quick-btn", { 'comment-dialog-quick-btn--ja': _ctx.isJapaneseLocale }]),
                color: "primary",
                variant: "flat",
                onClick: _ctx.toChildDiary
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('navigation.toTodayRecord')), 1),
                    _createVNode(_component_v_icon, {
                      class: "comment-dialog-quick-btn__chevron",
                      size: "20"
                    }, {
                      default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["class", "onClick"]),
              _createVNode(_component_v_btn, {
                class: _normalizeClass(["comment-dialog-quick-btn", { 'comment-dialog-quick-btn--ja': _ctx.isJapaneseLocale }]),
                color: "primary",
                variant: "flat",
                to: `/communication/ready-send-box`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('communication.goToReadySendBox')), 1),
                    _createVNode(_component_v_icon, {
                      class: "comment-dialog-quick-btn__chevron",
                      size: "20"
                    }, {
                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_v_btn, {
                class: _normalizeClass(["comment-dialog-quick-btn", { 'comment-dialog-quick-btn--ja': _ctx.isJapaneseLocale }]),
                color: "primary",
                variant: "flat",
                to: `/communication/draft`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_36, [
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('communication.goToDraft')), 1),
                    _createVNode(_component_v_icon, {
                      class: "comment-dialog-quick-btn__chevron",
                      size: "20"
                    }, {
                      default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_btn, {
                class: _normalizeClass(["comment-dialog-quick-btn", { 'comment-dialog-quick-btn--ja': _ctx.isJapaneseLocale }]),
                color: "primary",
                variant: "flat",
                onClick: _ctx.clickToParentsRecord
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('navigation.toParentsRecord')), 1),
                    _createVNode(_component_v_icon, {
                      class: "comment-dialog-quick-btn__chevron",
                      size: "20"
                    }, {
                      default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["class", "onClick"])
            ]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_textarea, {
              variant: "solo",
              flat: "",
              "hide-details": "",
              rows: "1",
              "auto-grow": "",
              name: "comment",
              placeholder: _ctx.$t('comment.placeholder'),
              "prepend-inner-icon": "mdi-note-outline",
              modelValue: _ctx.inputComment,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.inputComment) = $event)),
              clearable: "",
              class: "comment-area",
              style: {"white-space":"pre-wrap"},
              maxlength: _ctx.COMMENT_MAX_LENGTH,
              counter: _ctx.COMMENT_MAX_LENGTH,
              rules: _ctx.commentRules
            }, null, 8, ["placeholder", "modelValue", "maxlength", "counter", "rules"]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "text",
                  onClick: _ctx.saveComment,
                  loading: _ctx.commentLoading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('comment.save')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.deleteDialog,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.deleteDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_v_card_title, { class: "headline lighten-2" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('communication.deleteConfirm')), 1)
                ]),
                _: 1
              })
            ]),
            (_ctx.tempChat.body)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createVNode(_component_v_card_subtitle, {
                    style: {"white-space":"pre-line","user-select":"none"},
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.showLongText(_ctx.tempChat.body)), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[11] || (_cache[11] = () => (_ctx.deleteDialog = false)),
                    variants: "text"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "error",
                    class: "ml-5",
                    variant: "flat",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteChat())),
                    loading: _ctx.deleteLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.actionDialog,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.actionDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_43, [
              (_ctx.chatType != 'groupChat')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.clickDeleteDialog(_ctx.tempChat)))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.delete')), 1),
                      _createVNode(_component_v_icon, { right: "" }, {
                        default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                          _createTextVNode("mdi-trash-can-outline", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, { onClick: _ctx.onCopyTextCopy }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('communication.copyText')), 1),
                  _createVNode(_component_v_icon, { right: "" }, {
                    default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                      _createTextVNode("mdi-content-copy", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isTranslationDialog,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isTranslationDialog) = $event)),
      persistent: "",
      "max-width": "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TranslationModal, {
          isOpen: _ctx.isTranslationDialog,
          childId: _ctx.childId,
          selectedChat: _ctx.translationChat,
          onTranslate: _ctx.onTranslated,
          onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isTranslationDialog = false))
        }, null, 8, ["isOpen", "childId", "selectedChat", "onTranslate"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.absenceRegistDialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.absenceRegistDialog) = $event)),
      fullscreen: "",
      "hide-overlay": "",
      transition: "dialog-bottom-transition",
      class: "absence-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AbsenceModal, {
          isOpen: _ctx.absenceRegistDialog,
          childId: _ctx.childId,
          date: _ctx.date,
          nurseryId: _ctx.nurseryId,
          onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.absenceRegistDialog = false)),
          onPosted: _ctx.createAbsence
        }, null, 8, ["isOpen", "childId", "date", "nurseryId", "onPosted"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.absencedeleteDialog,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.absencedeleteDialog) = $event)),
      fullscreen: "",
      "hide-overlay": "",
      transition: "dialog-bottom-transition",
      class: "absence-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AbsenceDeleteModal, {
          chatsAbsence: _ctx.chatsAbsence,
          childId: _ctx.childId,
          date: _ctx.date,
          nurseryId: _ctx.nurseryId,
          onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.absencedeleteDialog = false)),
          onPosted: _ctx.deleteAbsence
        }, null, 8, ["chatsAbsence", "childId", "date", "nurseryId", "onPosted"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      class: "pt-5",
      modelValue: _ctx.isAttachmentUrls,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.isAttachmentUrls) = $event)),
      fullscreen: "",
      "hide-overlay": "",
      transition: "dialog-bottom-transition"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pdf_wrapper pt-5" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_v_toolbar, {
                class: "pdf_header",
                dark: "",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    icon: "",
                    dark: "",
                    onClick: _ctx.closeChatImg,
                    absolute: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_spacer)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_45, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showingUrls, (u) => {
                return (_openBlock(), _createElementBlock("div", { key: u }, [
                  (u.indexOf('.pdf?') >= 0)
                    ? (_openBlock(), _createElementBlock("object", {
                        key: 0,
                        data: u,
                        type: "application/pdf",
                        width: "100%",
                        height: "100%"
                      }, [
                        _createElementVNode("iframe", {
                          src: u,
                          width: "100%",
                          height: "100%"
                        }, null, 8, _hoisted_47),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("p", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.$t('communication.pdfFallback')), 1),
                            _cache[42] || (_cache[42] = _createTextVNode(": ", -1)),
                            _createElementVNode("a", { href: u }, _toDisplayString(_ctx.$t('communication.downloadPdf')), 9, _hoisted_49),
                            _cache[43] || (_cache[43] = _createTextVNode(".", -1))
                          ])
                        ])
                      ], 8, _hoisted_46))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        style: {"width":"100%"},
                        src: u
                      }, null, 8, _hoisted_50))
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dateDialogFlg,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dateDialogFlg) = $event)),
      width: "auto",
      "max-width": "100%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_locale_provider, {
          locale: _ctx.$i18n.locale
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_date_picker, {
              modelValue: _ctx.selectedDate,
              "onUpdate:modelValue": [
                _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selectedDate) = $event)),
                _ctx.dateSelected
              ],
              type: "date",
              "day-format": (date) => new Date(date).getDate(),
              "no-title": "",
              "hide-header": "",
              color: "primary"
            }, null, 8, ["modelValue", "day-format", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["locale"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.snackbar) = $event)),
      timeout: _ctx.timeout,
      outlined: "",
      top: "",
      color: "primary"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          color: "ourline-primary",
          variant: "text",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.snackbar = false))
        }, {
          default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
            _createTextVNode(" × ", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.snackBarText) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "timeout"])
  ]))
}